import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { KYMW7403Model } from "../kymw7403.model";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { ConfirmData } from "../vo/confirm-data.model";

// レスポンス構造
export type OutputRememberGoodsInfoResponce = {
  FileName: string
}

/**
 * 忘れず注文商品リスト出力
 * 
 */
@Injectable()
export class OutputRememberGoodsInfoService extends PlessJsonResponderSub<OutputRememberGoodsInfoResponce> {
  model: KYMW7403Model;
  vo: ConfirmData;
  successFunc: Function;

  /**
   * bodyにセットする値を返す
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputRememberGoodsInfoService
   */
  getBody() {
    return new PlessRequest({
      parameter: {
        ConfirmDate: this.vo.confirmDate,
        ConfirmUserId: this.vo.confirmUserId,
        CatalogId: this.model.catalogId,
        AheadEightWeeks: this.model.aheadEightWeeks,
        IncludeUnapproval: this.model.includeUnapproval
      }
    })
  }
  
  /**
   *  API呼び出し
   * @param model 
   * @param vo 
   * @param successFunc 
   * @memberof OutputRememberGoodsInfoService
   */
  execute(model: KYMW7403Model, vo: ConfirmData, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputRememberGoodsInfo', this.getBody());
  }

  /**
   * API成功後処理
   * @param data 
   * @memberof OutputRememberGoodsInfoService
   */
  success(data: OutputRememberGoodsInfoResponce): void {
    if ( this.successFunc !== null ) this.successFunc(data);
  }
}